import { Sparkles } from 'lucide-react'

import { Button } from '../../Button'

interface ResumeOptimizeButtonProps {
  onClick: () => void
  disabled?: boolean
  isRunning?: boolean
  loadingLabel?: string
}

export default function ResumeOptimizeButton({
  onClick,
  disabled,
  isRunning,
  loadingLabel = 'Optimizing…',
}: ResumeOptimizeButtonProps) {
  return (
    <Button
      type="button"
      variant="primary"
      primaryWeight="medium"
      className="gap-1.5"
      onClick={onClick}
      disabled={disabled}
      loading={isRunning}
      loadingLabel={loadingLabel}
      title="Optimize resume for a job (Full Flow 2)"
      data-testid="resume-optimize-button"
    >
      <Sparkles className="w-4 h-4" />
      Optimize resume
    </Button>
  )
}
